import { Grid, Radio, Text } from '@compono/ui';
import React, { ChangeEvent, FC } from 'react';
import { SkillStatus } from '../types';

interface SkillStatusInputProps {
  onChange: (name: SkillStatus) => void;
  value: string;
  disableReject?: boolean;
  isNewSkill?: boolean;
}

const SkillStatusInput: FC<SkillStatusInputProps> = ({
  onChange,
  value,
  disableReject,
  isNewSkill,
}) => {
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    onChange(e.target.value as SkillStatus);
  };

  return (
    <>
      <Text font="md" sx={{ paddingBottom: '5px' }}>
        Status
      </Text>
      <Grid
        sx={{
          gridTemplateColumns: 'min-content',
          alignItems: 'center',
          font: 'body',
        }}
      >
        {(value === 'draft' || isNewSkill) && (
          <Radio
            name="radio-group"
            value="draft"
            label="Draft"
            defaultChecked={value === 'draft'}
            onChange={handleChange}
            crossOrigin=""
          />
        )}
        <Radio
          name="radio-group"
          value="approved"
          label="Approve"
          defaultChecked={value === 'approved'}
          onChange={handleChange}
          crossOrigin=""
        />
        {!isNewSkill && (
          <Radio
            name="radio-group"
            value="rejected"
            label="Reject"
            defaultChecked={value === 'rejected'}
            onChange={handleChange}
            disabled={disableReject}
            crossOrigin=""
          />
        )}
      </Grid>
    </>
  );
};

export default SkillStatusInput;
